export default "__VITE_ASSET__CNdh2aNs__"